import React from 'react';
import { StaticQuery, graphql, Link } from 'gatsby';
import { GatsbyImage } from "gatsby-plugin-image";
import './carousel_default.scss';

import { Container, Row, Col, Carousel } from 'react-bootstrap';



const CarouselDefault = (data) => {
  // console.log(data)

  // Gracefully handle unknown types
  let type;
  try {
    type = data.props.relationships.field_content_type.info;
  } catch (e) {}

  let entries;
  switch (type) {
    case 'Case Study (Carousel)':
      entries = data.data.allNodeCaseStudy.edges;
      return (
        <CaseStudy
          data={entries}
          quoteIcon={data.data.quoteSVG}
          prevIcon={data.data.leftSVG}
          nextIcon={data.data.rightSVG}
        />
      );
    case 'Career Profiles (Carousel)':
      entries = data.data.allNodeCareerProfile.nodes;
      return (
        <CareerProfiles
          data={entries}
          prevIcon={data.data.leftSVG}
          nextIcon={data.data.rightSVG}
        />
      );
    default:
      entries = null;
      return <p>[No data found]</p>;
  }
};

const CaseStudy = (props) => {
  //console.log(props);
  let items = props.data;
  for (let i = 0; i < items.length; i++) {
    if (
      !items[i].node.field_testimonial ||
      null === items[i].node.field_testimonial
    ) {
      items.splice(i, i + 1);
    }
  }
  return (
    <Container>
      <Carousel
        className="p-carousel-default"
        prevIcon={
          <img
            src={props.prevIcon.publicURL}
            alt={'left arrow'}
            style={{
              height: '20px',
              marginTop: '15px',
              marginBottom: '15px',
            }}
          />
        }
        nextIcon={
          <img
            src={props.nextIcon.publicURL}
            alt={'right arrow'}
            style={{
              height: '20px',
              marginTop: '15px',
              marginBottom: '15px',
            }}
          />
        }
        controls={true}
        interval={null}
        indicators={false}
      >
        {items.map((entry, key) => {
          if (entry.node.field_testimonial) {
            return (
              <Carousel.Item key={key}>
                <Container>
                  <Row
                    className="justify-content-center"
                    style={{ minHeight: '320px' }}
                  >
                    <Col xs={8} className={'m-auto'}>
                      <img
                        src={props.quoteIcon.publicURL}
                        alt={'Quotation Icons'}
                        style={{
                          height: '30px',
                          marginTop: '15px',
                          marginBottom: '15px',
                        }}
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            entry.node.field_testimonial.processed,
                        }}
                      />
                      <Link
                        to={entry.node.path.alias}
                        className="btn btn-secondary"
                      >
                        Read the case study
                      </Link>
                    </Col>
                  </Row>
                </Container>
              </Carousel.Item>
            );
          }
        })}
      </Carousel>
    </Container>
  );
};
const CareerProfiles = (props) => {
  //console.log(items);
  let items = props.data;
  return (
    <Carousel
         className="p-carousel-default"
         prevIcon={
           <img
             src={props.prevIcon.publicURL}
             alt={'left arrow'}
             style={{
               height: '20px',
               marginTop: '15px',
               marginBottom: '15px',
               //marginBottom: '283px',
             }}
           />
         }
         nextIcon={
           <img
             src={props.nextIcon.publicURL}
             alt={'right arrow'}
             style={{
               height: '20px',
               //marginBottom: '283px',
               marginTop: '15px',
               marginBottom: '15px',
             }}
           />
         }
         controls={true}
         interval={null}
         indicators={false}
       >
         {items.map((entry, key) => {
           // console.log(entry);

           return (
             <Carousel.Item key={key}>
               <Container>
                 <Row className="justify-content-center">
                   {/* <Col
                     xs={12}
                     md={2}
                   > */}
                   <Col
                     xs={9}
                     md={5}
                     xl={3}
                     className="mt-auto mb-auto"
                   >
                     {entry.relationships.field_image && (
                       <div
                         className="d-block w-100"
                         style={{
                           position: 'relative',
                         }}
                       >
                         <GatsbyImage
                           image={
                             entry.relationships.field_image
                               .relationships.field_media_image
                               .localFile.childImageSharp
                               .gatsbyImageData
                           }
                           style={{
                             height: '100%',
                             width: '100%',
                             borderRadius: '50%',
                           }}
                         />
                       </div>
                     )}
                   </Col>

                   {/* <Col md={8} xs={12}>*/}
                   <Col
                     xs={9}
                     md={9}
                     xl={6}
                     className="mt-auto mb-auto"
                   >
                     <p>
                       {
                         entry.relationships.field_profile_body
                           .relationships.field_paragraph_s[0]
                           .field_paragraph
                       }
                     </p>
                     <h4>
                       {
                         entry.relationships.field_profile_body
                           .field_heading
                       }
                     </h4>
                   </Col>
                 </Row>
               </Container>
             </Carousel.Item>
           );
         })}
       </Carousel>
  );
};

export default (props) => (
  <StaticQuery
    query={graphql`{
  quoteSVG: file(relativePath: {eq: "icon_quotation_blue.svg"}) {
    publicURL
  }
  leftSVG: file(relativePath: {eq: "icon_arrow-left_purple.svg"}) {
    publicURL
  }
  rightSVG: file(relativePath: {eq: "icon_arrow-right_purple.svg"}) {
    publicURL
  }
  allNodeCaseStudy(sort: {fields: created, order: DESC}) {
    edges {
      node {
        title
        path {
          alias
        }
        field_testimonial {
          processed
        }
      }
    }
  }
  allNodeCareerProfile(sort: {fields: created, order: DESC}) {
    nodes {
      title
      relationships {
        field_profile_body {
          relationships {
            field_paragraph_s {
              field_paragraph
            }
          }
          field_heading
        }
        field_image {
          field_media_image {
            alt
          }
          relationships {
            field_media_image {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
            }
          }
        }
      }
    }
  }
}
`}
    render={(data) => <CarouselDefault data={data} {...props} />}
  />
);
